import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-request-failed',
    templateUrl: './request-failed.component.html',
    standalone: false
})
export class RequestFailedComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit() { }

}
